<template>
  <div class="survey">
    <div class="close-button" v-if="chooseNumberFlag === '04' && !enqueteAnswerMustFlag">
      <img src="@/assets/icon/sp-icon-purchase-close.svg" alt="">
    </div>
    <div class="header-radius-style"></div>
    <div id="mainDiv" :class="main_body">

       <!-- title -->
      <div class="survey-title">
        {{ title }}
      </div>

      <!-- 質問説明 -->
      <div class="ask-statement m-top-5 m-bottom-5">
        <span style="white-space: break-spaces;">{{ enqueteRemark }}</span>
      </div>

      <!-- body -->
      <div v-for="(item,index) in questionList" :key="index">
        <!-- el-radio -->
        <div class="m-bottom-5" v-if="item.questionInputMode === '02'">
          <div class="ask-title m-bottom-3">
            <span>{{ item.questionContent }}{{ $t('label.help.que.oneChoice') }}</span>
            <span class="master-start" v-if="item.mustFlag === true">*</span>
          </div>

          <div v-for="(answ,i) in item.questionAnswerList" :key="i">
            <div class="form-group m-bottom-2" v-if="answ.type === 'input'">
              <div>

                <el-radio v-model="radioValue" :disabled="true">
                  <template v-slot:label>
                    <span class="displaynone"></span>
                  </template>
                </el-radio>
              </div>
              <div class="ask-option">{{ answ.content }}</div>
            </div>

            <!-- その他 -->
            <div  v-if="answ.type === 'other'" class="m-bottom-2">
              <div class="form-group m-bottom-2">
                <div>

                  <el-radio v-model="radioValue" :disabled="true">
                    <template v-slot:label>
                      <span class="displaynone"></span>
                    </template>
                  </el-radio>

                </div>
                <div class="ask-option">{{ $t('label.help.que.other') }}</div>
              </div>
              <div>
                <el-input
                  :placeholder="$t('label.help.que.otherInput')"
                  />
              </div>
            </div>
          </div>
        </div>

        <!-- checkbox -->
        <div class="m-bottom-5" v-if="item.questionInputMode === '03'">
          <div class="ask-title m-bottom-3">
            <span>{{ item.questionContent }}{{ $t('label.help.que.multipleAnswers') }}</span>
            <span class="master-start" v-if="item.mustFlag === true">*</span>
          </div>

          <div v-for="(answ,i) in item.questionAnswerList" :key="i">
            <div class="form-group m-bottom-2" v-if="answ.type === 'input'">
              <div>
                <!-- <el-checkbox v-model="radioValue" :disabled="true">
                  <template v-slot:label>
                    <span class="displaynone"></span>
                  </template>
                </el-checkbox> -->

                <el-checkbox :disabled="true" v-model="selectValue">
                  <template v-slot:label>
                    <span class="displaynone"></span>
                  </template>
                </el-checkbox>

              </div>
              <div class="ask-option">{{ answ.content }}</div>
            </div>

            <!-- その他 -->
            <div v-if="answ.type === 'other'" class="m-bottom-2">
              <div class="form-group m-bottom-2">
                <div>
                  <el-checkbox :disabled="true" v-model="selectValue">
                    <template v-slot:label>
                      <span class="displaynone"></span>
                    </template>
                  </el-checkbox>
                </div>
                <div class="ask-option">{{ $t('label.help.que.other') }}</div>
              </div>
              <div>
                <el-input
                  :placeholder="$t('label.help.que.otherInput')"
                  />
              </div>
            </div>
          </div>
        </div>

        <!-- input -->
        <div class="m-bottom-5" v-if="item.questionInputMode === '04' ">
          <div class="ask-title m-bottom-3">
            <span>{{ item.questionContent }}{{ $t('label.help.que.oneChoice') }}</span>
            <span class="master-start" v-if="item.mustFlag === true">*</span>
          </div>
          <div>
            <el-select
              :disabled="true"
              :placeholder="$t('label.help.que.selectPlaceholder')"
              class="custom-select"/>
          </div>
        </div>

        <!-- input textarea -->
        <div class="m-bottom-5" v-if="item.questionInputMode === '01'">
          <div class="ask-title m-bottom-3">
            <span>{{ item.questionContent }}{{ $t('label.help.que.freeInput') }}</span>
            <span class="master-start" v-if="item.mustFlag === true">*</span>
          </div>
          <div>
            <el-input
              :placeholder= "$t('label.help.que.inputPlaceholder')"
              type="textarea"/>
          </div>
        </div>
      </div>

    </div>
    <hr class="delimit-8" v-if="chooseNumberFlag === '04'"/>
    <div class="main-end" v-if="chooseNumberFlag === '04'">
      <narrow-down>
        {{ $t("label.help.que.sendMessage") }}
      </narrow-down>
    </div>
  </div>
</template>

<script>
import narrowDown from "@/components/common/generalButton/NarrowDown";

export default {
  name: "UploadWithDrag",
  components: {
    narrowDown,
    // SpSmartButton
  },
  props: {
    questionList: Array,
    title: String,
    enqueteRemark: String,
    chooseNumberFlag: String,
    enqueteAnswerMustFlag:{
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      selectValue: false,
      radioValue: null
    };
  },
  computed: {
    main_body() {
      if (this.chooseNumberFlag === "03") {
        return 'main_body';
      } else if (this.chooseNumberFlag === "04") {
        return 'main_body-popup';
      } else {
        return 'main_body';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main_body {
  width: 500px;
  height: 1000px;
  // border-radius: 8px 8px 0px 0px;
  background-color: #292C32;
  padding: 0px 24px 48px 24px;
  overflow: overlay;
}
.main_body-popup {
  width: 500px;
  height: 500px;
  // border-radius: 8px 8px 0px 0px;
  background-color: #292C32;
  padding: 0px 24px 48px 24px;
  padding-left: 40px;
  overflow: overlay;
}
.main-end {
  width: 500px;
  height: 92px;
  background-color: #292C32;
  border-radius: 0px 0px 8px 8px;
  padding: 24px;
}
.survey-title {
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  text-align: center;
  color: #F2F6FA;
  word-wrap: break-word;
  margin-top: 20px;
}
.ask-statement {
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  text-align: left;
  color: #F2F6FA;
  word-wrap: break-word
}
.ask-title {
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
  color: #F2F6FA;
  word-wrap: break-word
}
::v-deep .el-radio__inner {
  border: 0 !important;
  background: -webkit-radial-gradient(circle closest-side, #d1d1cd 30%, #F2F2ED 50%);
  background-color: #F2F2ED;
  width: 26px !important;
  height: 26px !important;
  box-shadow: none !important;
}
.ask-option {
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 14px;
  font-weight: 300;
  line-height: 21px;
  text-align: left;
  color: #F2F6FA;
  word-wrap: break-word
}
::v-deep .el-input .el-input__inner {
  width: 100%;
  height: 40px !important;
  border-radius: 8px !important;
  background: #292C32;
  border: none;
  box-shadow: 2px 2px 2px 0px #0808094D inset, -4px -4px 4px 0px #1E222580 inset,
              1px -1px 2px 0px #0808091A inset, -1px -1px 2px 0px #0808094D !important;
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
  text-align: left;
  color: #5D646F !important;
}
::v-deep .el-checkbox__inner {
  border: 0 !important;
  border-radius: 100% !important;
  background-color: #F2F2ED !important;
  width: 26px !important;
  height: 26px !important;
  box-shadow: none !important;
  margin-right: 8px;
}
::v-deep .el-textarea__inner {
  pointer-events: none;
  width: 100% !important;
  height: 135px;
  border-radius: 8px !important;
  background: #292C32 !important;
  border: none !important;
  resize: none !important;
  box-shadow: 2px 2px 2px 0px #0808094D inset, -4px -4px 4px 0px #1E222580 inset,
              1px -1px 2px 0px #0808091A inset, -1px -1px 2px 0px #0808094D !important;
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 12px !important;
  font-weight: 300;
  line-height: 18px;
  text-align: left;
  color: #5D646F;
}
.master-start {
  color: #F56C6C;
  margin-right: 4px;
}
.survey ::v-deep {
  ::-webkit-scrollbar {
    width: 8px;
    height: 7px;
    background-color: #292C32;
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #292C32;
  }
}
.delimit-8 {
  border: 0;
  height: 1px;
  background-color: #5D646F;
}
.main-end ::v-deep {
  .my-button {
    cursor: default;
    width: 295px !important;
    height: 44px !important;
    box-shadow: none !important;
  }
}
.close-button {
  text-align: right;
}
.detail-button {
  cursor: pointer;
  text-align: right;
  margin-top: 8px;
  width: 70px;
  margin-left: 366px;
}
.detail-button ::v-deep {
  .my-button {
    width: 70px !important;
    height: 40px !important;
    box-shadow: none !important;
    padding: 10px 10px !important;
  }
}

.el-select ::v-deep{
  display: flex;
  position: unset;
  box-shadow: unset !important;
  .el-input__inner{
    background-color:#292C32 !important ;
  }
}
.el-checkbox ::v-deep{
  .el-checkbox__inner {
    border-radius: 4px !important;
    width: 18px !important;
    height: 18px !important;
    background-color: #292C32 !important;
    border: 1px solid #5D646F !important;
    border-radius: 0% !important;
  }
}

.el-radio ::v-deep{
  .el-radio__inner{
    width: 18px !important;
    height: 18px !important;
    border: 1px solid #5D646F !important;
    background: 0px !important;
  }
}

::v-deep .el-radio__input {
  border-radius: 50% !important;
}

::v-deep .el-radio__inner {
  border-radius: 50% !important;
}

::v-deep .el-icon-arrow-up:before {
  content: url('../../../assets/icon/sp-icon-drop-up-white.png') !important;
  zoom: 35% !important;
  color: #fff !important;
}
.header-radius-style{
  height: 20px;
  width: 500px;
  background: #292c32;
  border-radius: 10px 10px 0 0;
}
</style>
